var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlusBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 12757"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1561",
    x: 4.25,
    width: 1.5,
    height: 10,
    fill: "#2E66F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1562",
    y: 5.75,
    width: 1.5,
    height: 10,
    transform: "rotate(-90 0 5.75)",
    fill: "#2E66F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusBlue);
export default __webpack_public_path__ + "static/media/ic_plus_blue.7cd3c113828dcef522c8ae4387a9cded.svg";
export { ForwardRef as ReactComponent };